module.exports = __webpack_public_path__ + "img/section3_img.e96f8075.svg";